var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "mb-4 heading slider-align mt-4"
  }, [_vm.showCategory && _vm.marketListData && _vm.marketListData.length ? _c('sections-slider', {
    attrs: {
      "loading": _vm.isLoading,
      "list": _vm.marketListData,
      "subTitle": "Our Category",
      "hasInnerBackground": true,
      "hasButton": false,
      "showTitle": true,
      "withSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemLogo": true,
            "product": listItem,
            "incrementDecrementKey": false,
            "marketRoute": {
              name: `category-item`,
              params: {
                data: listItem.name
              }
            }
          }
        })], 1)];
      }
    }], null, false, 163680228)
  }) : _vm._e()], 1), _c('div', {
    staticClass: "blue pt-1 pb-3 heading mb-4"
  }), _c('div', {
    staticClass: "suggested-yellowLight pt-1 pb-3 heading"
  }, [_c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.newArrivals,
      "loading": _vm.isLoading,
      "subTitle": "New Arrivals",
      "hasBackground": false,
      "showTitle": true,
      "hasButton": true,
      "withoutSlider": true,
      "viewMorePage": {
        name: `new-arrivals-listing`,
        params: {
          items: `New Arrivals`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var listItem = _ref2.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }])
  })], 1), _c('div', {
    staticClass: "suggested-yellowLight pt-1 pb-3 heading"
  }, [_vm.itemSuggestions && _vm.itemSuggestions.length ? _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "loading": _vm.isLoading,
      "list": _vm.itemSuggestions,
      "subTitle": "Suggested For You",
      "hasBackground": false,
      "showTitle": true,
      "hasButton": true,
      "withoutSlider": true,
      "viewMorePage": {
        name: `product-listing`,
        params: {
          items: `Suggested For You`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var listItem = _ref3.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 113096431)
  }) : _vm._e()], 1), _c('div', {
    staticClass: "purpleLight pt-1 pb-3 heading"
  }, [_vm.trendingItems && _vm.trendingItems.length ? _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "loading": _vm.isLoading,
      "list": _vm.trendingItems,
      "subTitle": "What's Trending",
      "showTitle": true,
      "hasBackground": false,
      "hasButton": true,
      "withoutSlider": true,
      "viewMorePage": {
        name: `product-listing`,
        params: {
          items: `What's Trending`
        }
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var listItem = _ref4.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 113096431)
  }) : _vm._e()], 1), !_vm.shouldHideModal ? _c('b-modal', {
    attrs: {
      "id": "bv-add-address",
      "size": "lg",
      "centered": "",
      "title": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_c('v-container', [_c('add-address-modal')], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }